import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import CompanySubNav from '../../components/CompanySubNav';
import SEO from '../../components/SEO';
import '../../styles/contact-page.css';

export default function CompanyContact() {
  const [company, setCompany] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    let mounted = true;
    async function fetchCompany() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL || ''}/companies/${id}`);
        if (mounted) setCompany(res.data);
      } catch (err) {
        console.error(err);
      }
    }
    fetchCompany();
    return () => { mounted = false; };
  }, [id]);

  return (
    <div>
      <SEO
        title={company ? `Contact ${company.name}` : 'Company Contact'}
        description={company ? `Contact details for ${company.name} on Dofcan Oilserve.` : 'View company contact details on Dofcan Oilserve.'}
        path={`/company/${id}/contact`}
      />

      <CompanySubNav companyId={id} active="contact" />

      {!company ? (
        <div className="company-loading">Loading...</div>
      ) : (
        <div className="company-contact">
          <h1>Contact</h1>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-label">Email</span>
              <div className="contact-value">{company.contactEmail || 'N/A'}</div>
            </div>
            <div className="contact-item">
              <span className="contact-label">Phone</span>
              <div className="contact-value">{company.phone || 'N/A'}</div>
            </div>
            <div className="contact-item">
              <span className="contact-label">Address</span>
              <div className="contact-value">{company.address || 'N/A'}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
